import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './state/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const queryClient = new QueryClient();

const renderApp = () => {
  root.render(
    <React.StrictMode>
          <QueryClientProvider client={queryClient}>

      <Provider store={store}>
        <App />
      </Provider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

renderApp();

store.subscribe(() => {
  renderApp();

  console.log(store.getState());
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
